import React from "react";

export default function Blog() {
  return (
    <div className="max-w-3xl mx-auto py-16 px-4">
      <h1 className="text-4xl font-bold mb-4 text-gradient bg-gradient-to-r from-pink-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent">Blog</h1>
      <p className="text-lg text-gray-700 mb-8">Insights, updates, and inspiration from the Inflatein AI Studio team.</p>
      <div className="space-y-8">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-2xl font-semibold mb-2">Launching Pro Credits: More Power, More Flexibility</h2>
          <p className="text-gray-600 mb-2">July 2025</p>
          <p className="text-gray-700">We’re excited to introduce Pro Credits, a new way to access our most advanced AI image generation features. Learn how you can get more value and flexibility with our latest update.</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-2xl font-semibold mb-2">AI for Creators: How to Get the Most Out of Inflatein</h2>
          <p className="text-gray-600 mb-2">June 2025</p>
          <p className="text-gray-700">Discover tips, tricks, and best practices for using Inflatein AI Studio to create stunning visuals for your projects, business, or personal brand.</p>
        </div>
      </div>
    </div>
  );
}
